import { Grid, Typography } from '@mui/material'
import React from 'react'

export const DragInProgressEventError: React.FC = () => {
  return (
    <Grid container item xs={12} style={{ marginBottom: 20 }}>
      <Typography variant="h4">
        You can't drag and drop event which is In Progress or completed.
      </Typography>
    </Grid>
  )
}
